import { useTranslation } from '@shared/core';
import { animationTransition } from '@shared/utils/animationTransition';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { ChevronDown, ChevronRight } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import React from 'react';

const AccordionMenu = (props: { children: React.ReactNode }) => {
  return <Box className={'dashboard-accordion-menu'} backgroundColor={'mono2'} borderRadius={pxToRem(12)} overflow={'hidden'} {...props} />;
};

export type AccordionMenuItemProps = {
  label: string;
  icon: React.ReactNode;
  isNew?: boolean;
  showChevronDown?: boolean;
  link?: string;
  onClick?: () => void;
};

const Item: React.FC<AccordionMenuItemProps> = ({ label, icon, isNew, showChevronDown, link, ...props }) => {
  const { t2 } = useTranslation('adminDashboardV3');
  const { newBadgeLabel } = t2('dashboardAccordion', 'menu');

  return (
    <Flex
      role={'group'}
      height={pxToRem(88)}
      alignItems={'center'}
      columnGap={5}
      paddingX={pxToRem(20)}
      borderBottom={'1px solid'}
      borderBottomColor={'mono3'}
      cursor={'pointer'}
      color={'mono14'}
      transition={animationTransition('background-color', 'color')}
      _hover={{ backgroundColor: 'white', color: 'linkHover' }}
      _active={{ backgroundColor: 'mono2', color: 'linkActive' }}
      _lastChild={{ borderBottom: 'none' }}
      {...(link && {
        as: 'a',
        href: link
      })}
      {...props}
    >
      {icon}
      <TextV2 typographyVariant={'button2'} flexGrow={1}>
        {label}
      </TextV2>
      {isNew && (
        <Box paddingX={3} paddingY={1} borderRadius={5} backgroundColor={'buttonProductiveHover'}>
          <TextV2 typographyVariant={'label1'} fontWeight={600} color={'white'}>
            {newBadgeLabel}
          </TextV2>
        </Box>
      )}
      {showChevronDown ? (
        <ChevronDown size={'sm'} color={'mono12'} transition={animationTransition('color')} _groupHover={{ color: 'linkHover' }} _groupActive={{ color: 'linkActive' }} />
      ) : (
        <ChevronRight size={'sm'} color={'mono12'} transition={animationTransition('color')} _groupHover={{ color: 'linkHover' }} _groupActive={{ color: 'linkActive' }} />
      )}
    </Flex>
  );
};

AccordionMenu.Item = Item;

export { AccordionMenu };
